// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3bRGC","imageUploader":"EGiftCard_imageUploader__P8FYi"};